import React from 'react'
import Filtro from '../../comum/Filtro'
import FiltrosAdicionadosUsuarios from './FiltrosAdicionadosUsuarios'
import FiltroUsuarios from './FiltroUsuarios'
import PainelFiltragem from '../../comum/PainelFiltragem'

export const PainelFiltroUsuarios = () => (
  <Filtro PainelFiltro={FiltroUsuarios}/>
);

const PainelFiltrosUsuarios = () => (
  <PainelFiltragem
    Filtro={PainelFiltroUsuarios}
    FiltrosAdicionados={FiltrosAdicionadosUsuarios}/>
)

export default PainelFiltrosUsuarios
